<template>
  <a-modal
    :title="'绑定店铺'"
    :visible="visible"
    :confirmLoading="confirmLoading"

    okText="提交"
    cancelText="取消"
    @ok="handlerSubmit"
    @cancel="() => $emit('hideModal')"

    :afterClose="afterHideEditModal"
  >
    <a-form-model
      ref="editForm"
      :model="editForm"
      :rules="editFormRules"
      :label-col="{ span: 5 }"
      :wrapper-col="{ span: 18 }"
    >
      <a-form-model-item label="店铺选择" prop="storeId">
        <a-select
          show-search
          v-model="editForm.storeId"
          placeholder="请输入需要绑定的店铺名称"
          :default-active-first-option="false"
          :show-arrow="false"
          :filter-option="false"
          :not-found-content="null"
          @search="handleSearch"
        >
          <a-select-option v-for="(item,index) in shopList" :key="index" :value="item.id">
            {{ item.zfbShopName }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import { QueryShopIndex } from '@/apis/shop'

const editForm = {
  deviceId: undefined,
  storeId: undefined,
}
const editFormRules = {
  deviceId: [{ required: true, message: '设备未选择' }],
  storeId: [{ required: true, message: '请选择店铺！' }],
}


export default {
  name: 'ImportModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    obj: {
      type: Object,
      default: () => null
    }
  },
  data () {
    return {
      editForm,
      editFormRules,
      shopList:[],
      uploading: false,
      confirmLoading:false
    }
  },
  computed: {},
  watch: {
    visible: function (val){
      if (val && this.obj){
        this.$nextTick(() => {
          const { id } = this.obj
          this.editForm = { deviceId: id, storeId: undefined }
        })
      }
    }
  },
  created() {},
  methods: {
    // 提交模态框数据
    handlerSubmit() {
      this.$refs.editForm.validate(async valid => {
        if (valid) {
          this.$emit('submit', this.editForm)
          this.confirmLoading = true
        }
      })
    },
    // 编辑终端标识组模态框关闭后，重置相关数据
    afterHideEditModal() {
      this.$refs.editForm.resetFields()
      this.editForm = editForm
      this.confirmLoading = false
    },
    handleSearch(value){
      let _this = this
      QueryShopIndex({keyword: value}).then(res=>{
        _this.shopList = res.collection
      })
    }
  }
}
</script>

<style lang="less" scoped>
  ::v-deep .ant-modal{
    width: 700px !important
  }
  ::v-deep .ant-form-item{
    margin-bottom: 12px;
  }
  .ant-checkbox-group>.ant-checkbox-wrapper:first-child{
    margin-left: 8px !important;
  }
</style>
